<template>
    <div>

        <!-- 2. SYSTEM NOTIFICATION -->
        <div v-for="notification in systemNotifications" :key="notification.id" class="system-notification"
            :class="`notification-${notification.type.toLowerCase()}`">
            <div class="notification-content">
                <div class="notification-icon">
                    <i :class="getSystemIcon(notification.type)"></i>
                </div>
                <div class="notification-text">
                    <h4>{{ notification.title }}</h4>
                    <p>{{ notification.message }}</p>
                </div>
                <button @click="closeSystemNotification(notification.id)" class="close-btn">
                    <i class="pi pi-times"></i>
                </button>
            </div>
        </div>

        <!-- 3. BROADCAST Notification -->
        <div v-if="broadcastNotification" class="broadcast-notification">
            <div class="broadcast-banner">
                <div class="broadcast-icon">
                    <i class="pi pi-megaphone"></i>
                </div>
                <div class="broadcast-content">
                    <h3>{{ broadcastNotification.title }}</h3>
                    <p>{{ broadcastNotification.message }}</p>
                </div>
                <button @click="closeBroadcast" class="broadcast-close">
                    <i class="pi pi-times"></i>
                </button>
            </div>
        </div>

        <!-- 4. NOTIFY (Regular Notifications) -->
        <div class="notify-container">
            <transition-group name="notify-slide" tag="div">
                <div v-for="notify in regularNotifications" :key="notify.id" class="notify-item">
                    <div class="notify-content">
                        <div class="notify-icon">
                            <i class="pi pi-bell"></i>
                        </div>
                        <div class="notify-text">
                            <strong>{{ notify.title }}</strong>
                            <p>{{ notify.message }}</p>
                        </div>
                        <button @click="closeNotify(notify.id)" class="notify-close">
                            <i class="pi pi-times"></i>
                        </button>
                    </div>
                </div>
            </transition-group>
        </div>
    </div>
</template>

<script>
export default {
    name: 'App',

    data() {
        return {
            websocket: null,
            isConnected: false,
            isAuthenticated: false,
            user_id: null,
            tokenName: null,
            systemNotifications: [],
            broadcastNotification: null,
            regularNotifications: []
        }
    },

    mounted() {
        this.getToken();
        this.connectWebSocket();
        this.checkSocket();
    },

    beforeUnmount() {
        if (this.websocket) this.websocket.close();
    },

    methods: {
        getToken() {
            const url = window.location.href.split('/')[2].split(':');
            const tokenName = url[0] + '_' + url[1] + '_authToken'
            this.tokenName = tokenName;
        },

        connect() {
            const routeName = location.pathname;
            if (!this.websocket && routeName != '/auth/login') {
                this.connectWebSocket();
            }
        },

        checkSocket() {
            setInterval(this.connect, 10000);
        },

        // WebSocket Connection
        connectWebSocket() {
            const token = localStorage.getItem(this.tokenName);
            if (!token) return;

            this.websocket = new WebSocket('/websocket');

            this.websocket.onopen = () => {
                this.isConnected = true;
                console.log("WEB SOCKET CONNECTED");
                
                this.sendMessageToServer('auth', { token: token });
                this.$wsocket = this.websocket;
            };

            this.websocket.onmessage = (event) => {
                const data = JSON.parse(event.data);
                this.handleServerMessage(data);
            };

            this.websocket.onclose = () => {
                this.isConnected = false;
                this.isAuthenticated = false;
                setTimeout(() => this.connectWebSocket(), 3000);
            };
        },

        sendMessageToServer(type, payload) {
            if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
                this.websocket.send(JSON.stringify({ type, payload, timestamp: new Date() }));
            }
        },

        // Handle Server Messages
        handleServerMessage(data) {
            switch (data.type) {
                case 'auth_success':
                    this.isAuthenticated = true;
                    this.user_id = data.payload.user_id;
                    break;

                case 'session_killed':
                    this.showSessionKilled(data.payload);
                    break;

                case 'system_notification':
                    this.showSystemNotification(data.payload);
                    break;

                case 'broadcast':
                    this.showBroadcast(data.payload);
                    break;

                case 'notify':
                    this.showNotify(data.payload);
                    break;
            }
        },

        // 1. Session Killed Handler
        async showSessionKilled() {
            try {
                await this.axios.post('/auth/logout')
                localStorage.removeItem('authToken')
                localStorage.removeItem('userProfile')
                localStorage.removeItem('userPermissions')
                this.websocket = null;
                localStorage.clear();
                this.$router.push({ name: 'Login' });
            } catch (error) {
                this.websocket = null;
                localStorage.clear();
                this.$router.push({ name: 'Login' })
            }
        },

        // 2. System Notification Handler
        showSystemNotification(payload) {
            this.systemNotifications.push({
                ...payload,
                id: Date.now()
            });

            // Auto remove after 8 seconds
            setTimeout(() => {
                this.closeSystemNotification(payload.id);
            }, 8000);
        },

        closeSystemNotification(id) {
            this.systemNotifications = this.systemNotifications.filter(n => n.id !== id);
        },

        getSystemIcon(type) {
            const icons = {
                'SUCCESS': 'pi pi-check-circle',
                'INFO': 'pi pi-info-circle',
                'WARNING': 'pi pi-exclamation-triangle',
                'ERROR': 'pi pi-times-circle'
            };
            return icons[type] || 'pi pi-info-circle';
        },

        // 3. Broadcast Handler
        showBroadcast(payload) {
            this.broadcastNotification = payload;

            setTimeout(() => {
                this.broadcastNotification = null;
            }, 7000);
        },

        closeBroadcast() {
            this.broadcastNotification = null;
        },

        // 4. Regular Notify Handler
        showNotify(payload) {
            this.regularNotifications.push({
                ...payload,
                id: Date.now()
            });

            // Auto remove after 5 seconds
            setTimeout(() => {
                this.closeNotify(payload.id);
            }, 5000);
        },

        closeNotify(myid) {
            this.regularNotifications = this.regularNotifications.filter(item => {
                delete item[myid];
            });
        }
    }
}
</script>

<style scoped>
/* 1. SESSION KILLED STYLES */
.session-killed-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.session-killed-modal {
    background: #fff;
    padding: 30px;
    border-radius: 15px;
    text-align: center;
    max-width: 400px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.session-killed-modal .modal-icon {
    font-size: 60px;
    color: #e74c3c;
    margin-bottom: 20px;
}

.session-killed-modal h2 {
    color: #e74c3c;
    margin-bottom: 15px;
}

.logout-btn {
    background: #e74c3c;
    color: white;
    border: none;
    padding: 12px 25px;
    border-radius: 8px;
    cursor: pointer;
    font-weight: bold;
    margin-top: 20px;
}

.logout-btn:hover {
    background: #c0392b;
}

/* 2. SYSTEM NOTIFICATION STYLES */
.system-notification {
    position: fixed;
    top: 20px;
    right: 20px;
    width: 350px;
    margin-bottom: 10px;
    border-radius: 10px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    z-index: 1000;
    animation: slideInRight 0.3s ease;
}

.notification-success {
    background: #2ecc71;
    color: white;
}

.notification-info {
    background: #3498db;
    color: white;
}

.notification-warning {
    background: #f39c12;
    color: white;
}

.notification-error {
    background: #e74c3c;
    color: white;
}

.notification-content {
    display: flex;
    align-items: center;
    padding: 15px;
}

.notification-icon {
    font-size: 24px;
    margin-right: 15px;
}

.notification-text h4 {
    margin: 0 0 5px 0;
    font-weight: bold;
}

.notification-text p {
    margin: 0;
    opacity: 0.9;
}

.close-btn {
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    margin-left: auto;
    font-size: 16px;
}

/* 3. BROADCAST STYLES */
.broadcast-notification {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
}

.broadcast-banner {
    background: linear-gradient(45deg, #8e44ad, #3498db);
    color: white;
    display: flex;
    align-items: center;
    padding: 15px 20px;
    animation: slideDownBounce 0.5s ease;
}

.broadcast-icon {
    font-size: 28px;
    margin-right: 20px;
    animation: pulse 2s infinite;
}

.broadcast-content h3 {
    margin: 0 0 5px 0;
    font-weight: bold;
}

.broadcast-content p {
    margin: 0;
    opacity: 0.9;
}

.broadcast-close {
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    margin-left: auto;
    font-size: 20px;
}

/* 4. REGULAR NOTIFY STYLES */
.notify-container {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
}

.notify-item {
    background: white;
    border-left: 4px solid #3498db;
    border-radius: 8px;
    margin-bottom: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    width: 300px;
}

.notify-content {
    display: flex;
    align-items: center;
    padding: 15px;
}

.notify-icon {
    background: #3498db;
    color: white;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
}

.notify-text strong {
    display: block;
    margin-bottom: 5px;
    color: #2c3e50;
}

.notify-text p {
    margin: 0;
    color: #7f8c8d;
    font-size: 14px;
}

.notify-close {
    background: none;
    border: none;
    cursor: pointer;
    margin-left: auto;
    color: #bdc3c7;
}

/* ANIMATIONS */
@keyframes slideInRight {
    from {
        transform: translateX(100%);
        opacity: 0;
    }

    to {
        transform: translateX(0);
        opacity: 1;
    }
}

@keyframes slideDownBounce {
    from {
        transform: translateY(-100%);
    }

    to {
        transform: translateY(0);
    }
}

@keyframes pulse {

    0%,
    100% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.1);
    }
}

.notify-slide-enter-active,
.notify-slide-leave-active {
    transition: all 0.3s ease;
}

.notify-slide-enter-from {
    transform: translateX(100%);
    opacity: 0;
}

.notify-slide-leave-to {
    transform: translateX(100%);
    opacity: 0;
}
</style>